import React from "react";
import { Box } from "@mui/material";
import { APIProvider } from "@vis.gl/react-google-maps";

import { SearchInput } from "./components/SearchInput";
import { SearchResults } from "./components/SearchResults";
import { MapPreview } from "./components/MapPreview";
import { GoogleMapSearchProvider } from "./components/GoogleMapSearchContext";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box sx={{ mx: "auto", p: { xs: 2, sm: 2 }, width: "100%" }}>
      {children}
    </Box>
  );
};

const Content: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 3,
      }}
    >
      {children}
    </Box>
  );
};

export const GoogleMapSearch: React.FC<{
  googleApiKey: string;
  children?: React.ReactNode;
}> = ({ googleApiKey, children }) => (
  <APIProvider apiKey={googleApiKey} libraries={["places"]}>
    <GoogleMapSearchProvider>
      <Layout>
        <SearchInput />
        <Content>
          <SearchResults />
          <MapPreview />
        </Content>
        {children}
      </Layout>
    </GoogleMapSearchProvider>
  </APIProvider>
);

export default GoogleMapSearch;
